import { DiagramDefinition } from "../types";

export const m008Definition: DiagramDefinition = {
  id: "M-008",
  title: "Production Deployment Architecture",
  description:
    "Production architecture showing HTTPS traffic entering Nginx Reverse Proxy, managed by PM2/Systemd process supervisor, mounting persistent SSD disk storage (data.db, auxiliary.db, storage/) and running automated S3 backups.",
  viewBox: "0 0 850 360",
  nodes: [
    { id: "UserTraffic", kind: "client", label: "HTTPS Traffic", subtext: "Incoming Users", position: [100, 100], size: [140, 48] },
    { id: "NginxProxy", kind: "service", label: "Nginx Proxy", subtext: "SSL Termination", position: [270, 100], size: [140, 48] },
    { id: "ProcessManager", kind: "service", label: "PM2 / Systemd", subtext: "Process Supervisor", position: [440, 100], size: [150, 48] },
    { id: "NodeProcess", kind: "service", label: "Solarch Process", subtext: "Single Node Instance", position: [630, 100], size: [160, 48] },

    // Persistent Storage Cluster
    { id: "PersistentDisk", kind: "database", label: "Persistent SSD", subtext: "/mnt/disks/pb_data", position: [440, 240], size: [160, 48] },
    { id: "DataDB", kind: "database", label: "data.db", subtext: "App Records", position: [310, 330], size: [120, 42] },
    { id: "AuxDB", kind: "database", label: "auxiliary.db", subtext: "Logs & Audit", position: [440, 330], size: [120, 42] },
    { id: "StorageDir", kind: "database", label: "storage/", subtext: "Uploaded Files", position: [570, 330], size: [120, 42] },

    // Backup Engine
    { id: "CronBackup", kind: "service", label: "Cron Backup", subtext: "Automated Zip", position: [730, 240], size: [130, 48] },
    { id: "S3Bucket", kind: "service", label: "AWS S3 Bucket", subtext: "Remote Offsite", position: [730, 330], size: [130, 48] },
  ],
  edges: [
    { id: "e1", source: "UserTraffic", target: "NginxProxy", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "NginxProxy", target: "ProcessManager", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "ProcessManager", target: "NodeProcess", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "NodeProcess", target: "PersistentDisk", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e5", source: "PersistentDisk", target: "DataDB", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e6", source: "PersistentDisk", target: "AuxDB", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e7", source: "PersistentDisk", target: "StorageDir", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e8", source: "NodeProcess", target: "CronBackup", sourcePort: "bottom", targetPort: "top", routing: "orthogonal" },
    { id: "e9", source: "CronBackup", target: "S3Bucket", sourcePort: "bottom", targetPort: "top", routing: "straight", animated: true },
  ],
};
